export default __webpack_public_path__ + "static/media/my-tickets-inactive.d6e7ca38.svg";